import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_REFUSED_PAYMENTS: MijnRoute = {
    path: 'geweigerde-overboekingen',
    navigationEvent: 'toGeweigerd',
    regex: /^\/zelf-regelen\/geweigerde-overboekingen$/,
    webcomponent: 'mijn-transacties-geweigerd-webcomponent'
};
